import React, { useState } from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import VideocamIcon from '@material-ui/icons/Videocam';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { toUserTimezone } from 'utils';
import { ROLES } from '../../../../constant/userTypes';
import moment from 'moment'
import ProgramEndModal from './ProgramEndModal';
import DescriptionIcon from '@material-ui/icons/Description';

const useStyles = makeStyles((theme) => ({
  disabledBtn: {
    'marginBottom': theme.spacing(1),
    '&.Mui-disabled': {
      color: theme.palette.text.secondary,
      borderColor: theme.palette.text.secondary,
    },
  },
  box: {
    border: '2px solid',
    borderColor: theme.palette.background.default,
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap',
  },
  iconSizeMedium: {
    '& > svg': {
      fontSize: '24px !important',
    },
  },
}));

const ExerciseListItemMeeting = ({
  setModalOpen,
  exercise,
  studentExercise,
  user,
  student,
  isDisabled,
  onRequestSchedule,
  onRequestReschedule,
  onRequestCancel,
  handleModalOpen
}) => {
  const classes = useStyles();
  const { due_date, status, response, completed_at } = studentExercise;
  const { name, meeting_type } = exercise;
  const isDone = status === 'done';
  const isNoShow = status === 'noshow';
  const disableActions = user.type === ROLES.PARENT;
  const coachesAction = user.type === ROLES.HC || user.type === ROLES.LC || user.type === ROLES.ADMIN || user.type === ROLES.PARENT || user.type === ROLES.FA;
  const isCanceled = response?.canceled
  const canChangeSchedule = !student.is_trial;
  const [showModal, setShowModal] = useState(false);

  const cantChangeSchedule =
    user.type === ROLES.STUDENT && student.product_type === 'group';
  const current = moment()                                              // Added Current Date and Time
  const MeetingDateTimePassOut = user.type === ROLES.STUDENT && moment(due_date).isBefore(current.format())   //Disable for Only Student and Added comparison between scheduled date and current date


  if (!status && isDisabled) {
    return (
      <Box marginBottom={2}>
        <Button
          disabled
          classes={{
            root: classes.disabledBtn,
          }}
          fullWidth
          size="large"
          variant="outlined"
        >
          {name}
        </Button>
        <Typography component="p" align="center" variant="caption">
          Available after completing previous exercises
        </Typography>
      </Box>
    );
  } else if (!status) {
    return (
      <Box>

        <Box marginBottom={2}>
          {coachesAction || student.subscriptions[0].status === 'active' ?
            <Button
              fullWidth
              size="large"
              variant="outlined"
              color="primary"
              onClick={() => onRequestSchedule(studentExercise)}
              disabled={disableActions || cantChangeSchedule}
            >
              Schedule a {name}
            </Button>
            :
            <Button
              fullWidth
              size="large"
              variant="outlined"
              color="primary"
              onClick={() => setShowModal(true)}
              disabled={disableActions || cantChangeSchedule}
            >
              Schedule a {name}
            </Button>
          }
        </Box>
        {showModal &&

          <ProgramEndModal student={student} setShowModal={setShowModal} />
        }
      </Box>
    );
  }

  if (isCanceled) {
    return (
      <Box className={classes.box}>
        <Box marginRight={2}>
          <VideocamIcon color="disabled" />
        </Box>
        <Box flex={1}>
          <Typography variant="body2">
            {name} - Canceled on{' '}
            {completed_at === null ? toUserTimezone(due_date).format('MMMM D, YYYY') :
              toUserTimezone(completed_at).format('MMMM D, YYYY')}
          </Typography>
          <Typography variant="caption">
            {due_date &&
              `Scheduled at ${toUserTimezone(due_date, user.timezone).format(
                'MM-DD-YY • hh:mm z',
              )}`}
          </Typography>
        </Box>
      </Box>
    );
  }

  if (isDone) {
    return (
      <Box className={classes.box} style={{ cursor: 'pointer' }} onClick={() => handleModalOpen(studentExercise.id, name)}>
        <Box marginRight={2}>
          <VideocamIcon color="disabled" />
        </Box>
        <Box flex={1}>
          <Typography variant="body2">
            {name} - Completed on{' '}
            {completed_at === null ? toUserTimezone(due_date).format('MMMM D, YYYY') :
              toUserTimezone(completed_at).format('MMMM D, YYYY')}
          </Typography>
          <Typography variant="caption">
            {due_date &&
              `Scheduled at ${toUserTimezone(due_date, user.timezone).format(
                'MM-DD-YY • hh:mm z',
              )}`}
          </Typography>
        </Box>
        <Box marginLeft={2}>
          <DescriptionIcon color="disabled" style={{ fontSize: '17px', color: '#E0E0E0' }} />
        </Box>
      </Box>
    );
  }

  if (status === 'inprogress') {
    return (
      <Box className={classes.box}>
        <Box marginRight={2}>
          <VideocamIcon color="disabled" />
        </Box>
        <Box flex={1}>
          <Typography variant="body2">{name}</Typography>
          <Typography variant="caption">
            {`Scheduled at ${toUserTimezone(due_date, user.timezone).format(
              'MM-DD-YY • hh:mm z',
            )}`}
          </Typography>
        </Box>
        {!disableActions && (
          <Box>
            {coachesAction || student.subscriptions[0].status === 'active' ?
              <Button
                disabled={!canChangeSchedule || cantChangeSchedule || MeetingDateTimePassOut}  //Added MeetingDateTimePassOut for True or False 
                color="secondary"
                onClick={() => onRequestCancel(studentExercise)}
              >
                Cancel
              </Button> :
              <Button
                disabled={!canChangeSchedule || cantChangeSchedule || MeetingDateTimePassOut}  //Added MeetingDateTimePassOut for True or False 
                color="secondary"
                onClick={() => setShowModal(true)}
              >
                Cancel
              </Button>
            }
            {coachesAction || student.subscriptions[0].status === 'active' ?
              <Button
                disabled={!canChangeSchedule || cantChangeSchedule || MeetingDateTimePassOut}   //Added MeetingDateTimePassOut for True or False 
                style={{ marginLeft: 8, marginRight: 8 }}
                onClick={() => onRequestReschedule(studentExercise)}
              >
                Reschedule
              </Button> :
              <Button
                disabled={!canChangeSchedule || cantChangeSchedule || MeetingDateTimePassOut}   //Added MeetingDateTimePassOut for True or False 
                style={{ marginLeft: 8, marginRight: 8 }}
                onClick={() => setShowModal(true)}
              >
                Reschedule
              </Button>

            }
            {coachesAction || student.subscriptions[0].status === 'active' ? <a
              target="_blank"
              rel="noreferrer noopener"
              href={
                student.group
                  ? `/meeting/group/${student.group.group_id}`
                  : `/meeting/${student.sub}`
              }
            >
              <Button
                classes={{
                  iconSizeMedium: classes.iconSizeMedium,
                }}
                endIcon={<ArrowForwardIcon color="primary" />}
              >
                Start
              </Button>
            </a> :
              <Button
                classes={{
                  iconSizeMedium: classes.iconSizeMedium,
                }}
                endIcon={<ArrowForwardIcon color="primary" />}
                onClick={() => setShowModal(true)}
              >
                Start
              </Button>
            }


          </Box>
        )}
        {showModal &&

          <ProgramEndModal student={student} setShowModal={setShowModal} />
        }
      </Box>
    );
  }

  if (isNoShow) {
    return (
      <Box className={classes.box}>
        <Box marginRight={2}>
          <VideocamIcon color="disabled" />
        </Box>
        <Box flex={1}>
          <Typography variant="body2">
            {name} - No-Show on{' '}
            {completed_at === null ? toUserTimezone(due_date).format('MMMM D, YYYY') :
              toUserTimezone(completed_at).format('MMMM D, YYYY')}
          </Typography>
          <Typography variant="caption">
            {due_date &&
              `Scheduled at ${toUserTimezone(due_date, user.timezone).format(
                'MM-DD-YY • hh:mm z',
              )}`}
          </Typography>
        </Box>
      </Box>
    );
  }

  return null;
};

export default ExerciseListItemMeeting;
